import { render, staticRenderFns } from "./Adduser.vue?vue&type=template&id=fbcb29a4&"
import script from "./Adduser.vue?vue&type=script&lang=js&"
export * from "./Adduser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports